module.exports = __webpack_public_path__ + "static/christina-yacht-0-c07b39caa9849d30b041a5cbcdd90ac6.jpg";